import "./SaudiCeramicOvenMaintenanceRiyadh.module.css";
import Header from "@/reusable_sections/Header";
import HeroAlKhazafRepair from "./sections/HeroAlKhazafRepair";
import SaudiCeramicOvenMaintenance from "./sections/SaudiCeramicOvenMaintenance";
import Footer from "@/reusable_sections/Footer";
export default function SaudiCeramicOvenMaintenanceRiyadhPage() {
  return <div>
      <Header />
      <HeroAlKhazafRepair />
      <SaudiCeramicOvenMaintenance />
      <Footer />
    </div>;
}